import React from "react";

interface ChevronType {
  className?: string;
}

const Chevron: React.FC<ChevronType> = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M0.998535 1.5L5.99854 6.5L10.9985 1.5"
        stroke="#123333"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Chevron;
